import * as Yup from 'yup';

export default Yup.object().shape({
  paymentForm: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD')
});
